import * as React from "react";
import { Stepper, StepLabel, Step } from "@material-ui/core";
import { useTypedSelector } from "../../state/store";

var StageVisualizer = function StageVisualizer() {
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });

  if (!languageInfo || !quiz) {
    return React.createElement("div", null);
  }

  if (quizDisabled) {
    return React.createElement("div", {
      style: {
        display: "none"
      }
    });
  }

  var stageLabels = languageInfo.stage;
  var steps = [stageLabels.answerStageLabel, stageLabels.givingPeerReviewsStageLabel, stageLabels.receivingPeerReviewsStageLabel, stageLabels.evaluationStageLabel];
  var answerStatus = quizAnswer.status ? quizAnswer.status : null;
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var peerReviewsGiven = userQuizState ? userQuizState.peerReviewsGiven : 0;
  var peerReviewsReceived = userQuizState ? userQuizState.peerReviewsReceived : 0;
  var peerReviewsRequired = quiz.course.minPeerReviewsGiven;
  var peerReviewsReceivedRequired = quiz.course.minPeerReviewsReceived;
  var activeStep = 0;

  if (answerLocked) {
    activeStep = 1;

    if (peerReviewsGiven >= peerReviewsRequired) {
      activeStep = 2;

      if (peerReviewsReceived >= peerReviewsReceivedRequired) {
        activeStep = 3;
      }
    }

    if (answerStatus === "rejected" || answerStatus === "spam") {
      activeStep = 3;
    }

    if (answerStatus === "confirmed") {
      activeStep = 4;
    }
  }

  return React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true
  }, steps.map(function (label) {
    return React.createElement(Step, {
      key: label
    }, React.createElement(StepLabel, null, label));
  }));
};

export default StageVisualizer;